'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteLegacyFitnessActivity = exports.deleteFitnessActivity = exports.updateFitnessActivity = exports.createFitnessActivity = exports.fetchFitnessActivities = exports.deserializeFitnessActivity = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _units = require('../../../utils/units');

var _graphql = require('../../../utils/graphql');

var _base = require('../../../utils/base64');

var _jsonDate = require('../../../utils/jsonDate');

var _jsonDate2 = _interopRequireDefault(_jsonDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getFitnessId = function getFitnessId(source, activity) {
  if (activity.id) return activity.id;

  switch (source) {
    case 'fitness':
      return (0, _base.encodeBase64String)(['Timeline:FUNDRAISING', activity.PageGuid, 'FITNESS:STRAVA', activity.ExternalId].join(':'));
    case 'manual':
      // legacy activity created via Consumer API
      if (!activity.ExternalId) return null;

      return (0, _base.encodeBase64String)(['Timeline:FUNDRAISING', activity.PageGuid, activity.ExternalId].join(':'));
    default:
      return null;
  }
};

var getExternalId = function getExternalId(source, activity) {
  switch (source) {
    case 'fitness':
      return activity.ExternalId || activity.activityId;
    default:
      return null;
  }
};

var getMetricValue = function getMetricValue(metric) {
  switch (typeof metric === 'undefined' ? 'undefined' : _typeof(metric)) {
    case 'object':
      return (0, _get2.default)(metric, 'value', 0);
    default:
      return metric;
  }
};

var deserializeFitnessActivity = exports.deserializeFitnessActivity = function deserializeFitnessActivity() {
  var activity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  var activityType = (activity.activityType || activity.Type || '').toLowerCase();
  var source = (activity.type || activity.ActivityType || '').toLowerCase();

  return {
    campaign: activity.CampaignGuid,
    charity: activity.CharityId,
    createdAt: activity.createdAt || (0, _jsonDate2.default)(activity.DateCreated),
    description: activity.Description || activity.message,
    distance: getMetricValue(activity.distance || activity.Value),
    duration: getMetricValue(activity.duration || activity.TimeTaken),
    elevation: getMetricValue(activity.elevation || activity.Elevation),
    externalId: getExternalId(source, activity),
    eventId: activity.EventId,
    id: getFitnessId(source, activity),
    legacyId: activity.Id,
    manual: activity.ActivityType === 'Manual' || activity.ActivityType === 'manual' || activity.type === 'MANUAL',
    page: activity.PageGuid,
    polyline: activity.mapPolyline,
    slug: activity.PageShortName,
    source: source,
    sourceUrl: source === 'fitness' ? 'https://www.strava.com/activities/' + (activity.ExternalId || activity.activityId) : null,
    teamId: activity.TeamGuid,
    title: activity.Title || activity.title,
    type: activityType
  };
};

var fetchFitnessActivities = exports.fetchFitnessActivities = function fetchFitnessActivities() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  var query = {
    limit: params.limit || 100,
    offset: params.offset || 0,
    start: params.startDate,
    end: params.endDate
  };

  if (params.page) {
    if (params.useLegacy) {
      return (0, _client.get)('/v1/fitness/fundraising/' + params.page, query).then(function (response) {
        return response.activities;
      });
    }

    var page = params.page,
        after = params.after,
        allActivities = params.allActivities,
        _params$results = params.results,
        results = _params$results === undefined ? [] : _params$results;


    var graphQLQuery = '\n      {\n        page(type: FUNDRAISING, slug: "' + page + '") {\n          timeline(first: 20' + (after ? ', after: "' + after + '"' : ' ') + ') {\n            pageInfo {\n              hasNextPage\n              endCursor\n            }\n            nodes {\n              id\n              legacyId\n              message\n              type\n              createdAt\n              fitnessActivity {\n                title\n                activityId\n                activityType\n                mapPolyline\n                distance { value unit }\n                elevation { value unit }\n                duration { value unit }\n              }\n            }\n          }\n        }\n      }\n    ';

    return _client.servicesAPI.post('/v1/justgiving/graphql', { query: graphQLQuery }).then(function (response) {
      return response.data;
    }).then(function (result) {
      var data = (0, _get2.default)(result, 'data.page.timeline', {});
      var _data$pageInfo = data.pageInfo,
          pageInfo = _data$pageInfo === undefined ? {} : _data$pageInfo,
          _data$nodes = data.nodes,
          nodes = _data$nodes === undefined ? [] : _data$nodes;

      var updatedResults = [].concat(_toConsumableArray(results), _toConsumableArray(nodes));

      if (allActivities && pageInfo.hasNextPage) {
        return fetchFitnessActivities({
          page: page,
          after: pageInfo.endCursor,
          results: updatedResults,
          allActivities: true
        });
      } else {
        return updatedResults.filter(function (activity) {
          return activity.fitnessActivity;
        }).map(function (activity) {
          return _extends({}, activity, (0, _get2.default)(activity, 'fitnessActivity', {}));
        });
      }
    });
  }

  if (params.team) {
    return (0, _client.get)('/v1/fitness/teams/' + params.team, query).then(function (response) {
      return response.activities;
    });
  }

  if (params.campaign) {
    return (0, _client.get)('/v1/fitness/campaign', _extends({}, query, { campaignGuid: params.campaign }), {}, { paramsSerializer: _params.paramsSerializer }).then(function (response) {
      return response.activities;
    });
  }

  return (0, _params.required)();
};

var activityType = function activityType(type) {
  switch (type) {
    case 'bike':
    case 'ride':
      return 'RIDE';
    case 'swim':
      return 'SWIM';
    case 'run':
      return 'RUN';
    case 'hike':
      return 'HIKE';
    default:
      return 'WALK';
  }
};

var createFitnessActivity = exports.createFitnessActivity = function createFitnessActivity(_ref) {
  var caption = _ref.caption,
      description = _ref.description,
      _ref$distance = _ref.distance,
      distance = _ref$distance === undefined ? 0 : _ref$distance,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 0 : _ref$duration,
      durationUnit = _ref.durationUnit,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === undefined ? 0 : _ref$elevation,
      elevationUnit = _ref.elevationUnit,
      pageId = _ref.pageId,
      pageSlug = _ref.pageSlug,
      startedAt = _ref.startedAt,
      title = _ref.title,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'walk' : _ref$type,
      _ref$token = _ref.token,
      token = _ref$token === undefined ? (0, _params.required)() : _ref$token,
      unit = _ref.unit,
      userId = _ref.userId,
      useLegacy = _ref.useLegacy;

  var headers = { Authorization: 'Bearer ' + token };

  if (!useLegacy) {
    if (!pageId || !userId) {
      return (0, _params.required)();
    }

    var createdDate = startedAt ? 'createdDate: "' + (0, _moment2.default)(startedAt).toISOString() + '"' : '';

    var message = description ? 'message: "' + description + '"' : '';

    var query = '\n      mutation {\n        createTimelineEntry (\n          input: {\n            type: FUNDRAISING\n            pageId: "' + pageId + '"\n            creatorGuid: "' + userId + '"\n            ' + createdDate + '\n            ' + message + '\n            fitness: {\n              title: "' + (title || caption || '') + '",\n              activityType: ' + activityType(type) + '\n              distance: ' + (0, _units.convertToMeters)(distance, unit) + '\n              duration: ' + (0, _units.convertToSeconds)(duration, durationUnit) + '\n              elevation: ' + (0, _units.convertToMeters)(elevation, elevationUnit || unit) + '\n            }\n          }\n        ) {\n          id\n          message\n          createdAt\n          fitnessActivity {\n            title\n            activityType\n            distance { value unit }\n            elevation { value unit }\n            duration { value unit }\n          }\n        }\n      }\n    ';

    return _client.servicesAPI.post('/v1/justgiving/graphql', { query: query }, { headers: headers }).then(function (response) {
      return (0, _graphql.extractData)(response);
    }).then(function (result) {
      return _extends({}, (0, _get2.default)(result, 'data.createTimelineEntry', {}), (0, _get2.default)(result, 'data.createTimelineEntry.fitnessActivity', {}));
    });
  }

  if (!pageSlug) {
    return (0, _params.required)();
  }

  var params = {
    dateCreated: (0, _moment2.default)(startedAt).isBefore((0, _moment2.default)(), 'day') ? (0, _moment2.default)(startedAt).format('DD/MM/YYYY') : null,
    description: description,
    distance: (0, _units.convertToMeters)(distance, unit),
    duration: (0, _units.convertToSeconds)(duration, durationUnit),
    elevation: (0, _units.convertToMeters)(elevation, elevationUnit || unit),
    shortName: pageSlug,
    title: title || caption,
    type: type
  };

  return (0, _client.post)('/v1/fitness', params, { headers: headers });
};

var updateFitnessActivity = exports.updateFitnessActivity = function updateFitnessActivity() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _params.required)();
  return Promise.reject(new Error('This method is not supported by JustGiving'));
};

var deleteFitnessActivity = exports.deleteFitnessActivity = function deleteFitnessActivity(_ref2) {
  var _ref2$id = _ref2.id,
      id = _ref2$id === undefined ? (0, _params.required)() : _ref2$id,
      page = _ref2.page,
      _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token,
      useLegacy = _ref2.useLegacy;

  if (useLegacy) {
    return deleteLegacyFitnessActivity({ id: id, page: page, token: token });
  }

  var query = '\n    mutation {\n      deleteTimelineEntry (\n        input: {\n          id: "' + id + '"\n        }\n      )\n    }\n  ';

  var headers = { Authorization: 'Bearer ' + token };

  return _client.servicesAPI.post('/v1/justgiving/graphql', { query: query }, { headers: headers }).then(function (response) {
    return (0, _graphql.extractData)(response);
  }).then(function (result) {
    return (0, _get2.default)(result, 'data.deleteTimelineEntry');
  });
};

var deleteLegacyFitnessActivity = exports.deleteLegacyFitnessActivity = function deleteLegacyFitnessActivity(_ref3) {
  var _ref3$id = _ref3.id,
      id = _ref3$id === undefined ? (0, _params.required)() : _ref3$id,
      _ref3$page = _ref3.page,
      page = _ref3$page === undefined ? (0, _params.required)() : _ref3$page,
      _ref3$token = _ref3.token,
      token = _ref3$token === undefined ? (0, _params.required)() : _ref3$token;
  return (0, _client.destroy)('/v1/fitness/fundraising/' + page + '/' + id, {
    headers: { Authorization: 'Bearer ' + token }
  });
};